import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('NavBar'),_c('router-view',{staticClass:"px-2 py-9"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }